$(window).scroll(function(){

	// Add parallax scrolling to all images in .paralax-image container
	$('.parallax-image').each(function(){
		// only put top value if the window scroll has gone beyond the top of the image
		if ($(this).offset().top < $(window).scrollTop()) {
			// Get ammount of pixels the image is above the top of the window
			var difference = $(window).scrollTop() - $(this).offset().top;
			// Top value of image is set to half the amount scrolled
			// (this gives the illusion of the image scrolling slower than the rest of the page)
			var half = (difference / 2) + 'px';

			$(this).find('img').css('top', half);
		} else {
			// if image is below the top of the window set top to 0
			$(this).find('img').css('top', '0');
		}
	});
  
  	// Add parallax scrolling to all images in .paralax-image container
	$('.parallax-video').each(function(){
		// only put top value if the window scroll has gone beyond the top of the image
		if ($(this).offset().top < $(window).scrollTop()) {
			// Get ammount of pixels the image is above the top of the window
			var difference = $(window).scrollTop() - $(this).offset().top;
			// Top value of image is set to half the amount scrolled
			// (this gives the illusion of the image scrolling slower than the rest of the page)
			var half = (difference / 2) + 'px';

			$(this).find('video').css('top', half);
		} else {
			// if image is below the top of the window set top to 0
			$(this).find('video').css('top', '0');
		}
	});
});
jQuery( document ).ready(function() {
  	jQuery( ".sub-blocks" ).each(function() {
    	jQuery(this).insertAfter(jQuery(this).parents('.image-with-text-overlay__container').find("h2.image-with-text-overlay__heading"));
    });
	
	jQuery('ul.tabs li').click(function(){
		var tab_id = jQuery(this).attr('data-tab');

		jQuery('ul.tabs li').removeClass('current');
		jQuery('.tab-content').removeClass('current');

		jQuery(this).addClass('current');
		jQuery("#"+tab_id).addClass('current');
	});
    
  	if (window.matchMedia('screen and (max-width: 767px)').matches) {
      	jQuery("#shopify-section-1590575979720 button.button").trigger("click");
      jQuery('.image-with-text-overlay__banner').click(function(){
          jQuery(this).parents().find('.plus-hover-container span').css('color', 'transparent');
      });
      jQuery('.plus-hover-container span').click(function(){
          jQuery(this).parents().find('.plus-hover-container span').css('color', 'transparent');
          if(jQuery(this).hasClass( "dot3" )) {
//           	jQuery(this).css('color', '#4087dc');
            jQuery(this).parents().find("#shopify-section-1590557338025 span.dot3").css('color', '#00008b');
            jQuery(this).parents().find("#shopify-section-1590226348157 span.dot3").css('color', '#fff');
          }else if(jQuery(this).hasClass( "dot4" )) {
//           	jQuery(this).css('color', '#4087dc');
            jQuery(this).parents().find("#shopify-section-1590557338025 span.dot4").css('color', '#00008b');
            jQuery(this).parents().find("#shopify-section-1590226348157 span.dot4").css('color', '#fff');
          }else{
          	jQuery(this).css('color', '#fff');
          }
      });
      jQuery('.dots-hover-container span').click(function(){
          jQuery(this).parents().find('.dots-hover-text-column').css('display', 'none');
          jQuery(this).find('.dots-hover-text-column').css('display', 'block');
      });
    }
});